import { BaseService } from './BaseService';
import type { UserDto } from '../types/auth';

/**
 * Authentication service for B2C-only auth.
 * Handles getCurrentUser and ensureCurrentUser (post-B2C login provisioning).
 */
export class AuthService extends BaseService {
  /**
   * Gets the current authenticated user. Optionally pass a token (e.g. right after login) so the request uses it without relying on stored auth.
   */
  async getCurrentUser(token?: string): Promise<UserDto> {
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;
    return this.get<UserDto>('/users/me', config);
  }

  /**
   * Ensures the current user exists on the backend (JIT from verified identity claims). Tenant membership is reconciled from the IdP directory, not from token organization claims. Called on B2C login success.
   */
  async ensureCurrentUser(token: string): Promise<void> {
    await this.post<void>('/users/me/ensure', undefined, {
      headers: { Authorization: `Bearer ${token}` },
    });
  }
}

export const authService = new AuthService();
